/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Col } from 'antd';

import { List } from '@atoms';
import { InfoItem } from '@molecules';
import { postBy } from '@utils';

import PostForm from './PostForm';

const PostItem = ({ post, parentId, parentType, isEditing, toggleEdit, liveBlogId }) => (
  <List.Item>
    {!isEditing && (
      <InfoItem
        style={{ margin: 0 }}
        onClick={() => toggleEdit(post)}
        description={postBy(post, { withBackdatePublish: false })}
      >
        {post.title}
      </InfoItem>
    )}
    {isEditing && (
      <Col flex="1" style={{ padding: '20px 0 40px 0' }}>
        <PostForm
          parentId={parentId}
          parentType={parentType}
          initialValues={post}
          onCancel={() => toggleEdit(post)}
          onSuccess={() => toggleEdit(post)}
          liveBlogId={liveBlogId}
        />
      </Col>
    )}
  </List.Item>
);

export default PostItem;
